// extracted by mini-css-extract-plugin
export var createdDate = "_i6-1";
export var divider = "_i6-2";
export var headerDivider = "_i6-3";
export var messagesCard = "_i6-0";
export var messagesContainer = "_i6-7";
export var messagesContainerWrapper = "_i6-4";
export var pointerCapturingButtonBoxes = "_i6-a";
export var showLeftPanelButton = "_i6-9";
export var showMoreButton = "_i6-c";
export var showMoreButtonContainer = "_i6-b";
export var summaryTitle = "_i6-6";
export var systemMessageCardWrapper = "_i6-d";
export var topButtons = "_i6-8";
export var withPadding = "_i6-5";